export const actions = {
  async initializeChat({ commit, state }, isLink) {
    if (!window._laq) {
      window._laq = []
    }
    /*eslint-disable */
    if (isLink) {
      await window._laq.push(function() {
        try {
          liveagent.showWhenOnline(
            '573i0000000XZJk',
            document.getElementById('liveagent_button_online_573i0000000XZJk')
          )
          liveagent.showWhenOnline(
            '573i0000000XZJk',
            document.getElementById('liveagent_text_online_573i0000000XZJk')
          )
          liveagent.showWhenOffline(
            '573i0000000XZJk',
            document.getElementById('liveagent_button_offline_573i0000000XZJk')
          )
          liveagent.showWhenOffline(
            '573i0000000XZJk',
            document.getElementById('liveagent_text_offline_573i0000000XZJk')
          )
        } catch (error) {}
      })
    } else {
      await window._laq.push(function() {
        try {
          liveagent.showWhenOnline(
            '573i0000000XZJk',
            document.getElementById('liveagent_button_online_573i0000000XZJkX')
          )
          liveagent.showWhenOnline(
            '573i0000000XZJk',
            document.getElementById('liveagent_text_online_573i0000000XZJkX')
          )
          liveagent.showWhenOffline(
            '573i0000000XZJk',
            document.getElementById('liveagent_button_offline_573i0000000XZJkX')
          )
          liveagent.showWhenOffline(
            '573i0000000XZJk',
            document.getElementById('liveagent_text_offline_573i0000000XZJkX')
          )
        } catch (error) {}
      })
    }
    /*eslint-disable */
  },
}
